import { Box } from '@mui/material';
import { styled } from '@mui/system';

export const AccordionSummaryBox = styled(Box, {})({
  display: 'flex',
  padding: '0 20px',

  gap: 20,
  justifyContent: 'space-between',
  alignItems: 'center',

  '& .MuiAccordionSummary-root': {
    flexGrow: 1,

    justifyContent: 'center',
  },
});
